import React from 'react'
import greenIcon from "../../Assets/Svg/green-icon.svg";
import redIcon from "../../Assets/Svg/red-icon.svg";
import personIcon from "../../Assets/Svg/person-icon.svg"
import clockIcon from "../../Assets/Svg/clock-icon.svg";
import "./TimestampCycle.css";
import { formatISODate } from '../../Utils/Utils';

const TimestampCard = ({e, index}) => {
  
  return (
     <div className="ts-main-div" key={index}>
                <div className="ts-img-container">
                  <img
                    src={e?.approve_reject_status == 2 ? redIcon : greenIcon}
                    alt=""
                  />
                  <div class="ts-vertical-line"></div>
                </div>
                <div className="" style={{width:"100%"}}>
                  <div className="timeStampCardTitle">
                    <p className="ts-status">
                    {e?.approve_reject_status == 2 ? "Rejected" : "Approved"}
                  </p>
                  <h3>{e?.dayDifference}</h3>
                  </div>
                  
                  <div className="ts-time-div d-flex">
                    {" "}
                    <div className='ts-Icon-Text-Wrapper'>
                       <img src={clockIcon} alt="" />{" "}
                    <p className="ts-date">{formatISODate(e?.action_date_time)} </p>
                    </div>
                   
                    <div className="ts-vl"></div>
                    <div className='ts-Icon-Text-Wrapper'>
                      <img
                      src={personIcon}
                      alt=""
                      className="ts-person-icon"
                    />{" "}
                    <p>
                      {e?.user_name}
                      {/* ({e?.current_group_name}) */}
                    </p>
                    </div>
                  </div>
                </div>
              </div>
  )
}

export default TimestampCard